export default __webpack_public_path__ + "static/ci-20972ed25c897048b41aa89e4e03eaf4.svg";